import { render, staticRenderFns } from "./routes.vue?vue&type=template&id=29251888&"
import script from "./routes.vue?vue&type=script&lang=js&"
export * from "./routes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports